import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Redirect } from "react-router-dom";
import './assets/styles.scss';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import MessagesDe from './intl-de';
import MessagesEn from './intl-en';
import {LocalizedSwitch} from "./basic/LocalizedSwitch";
import {LocalizedRouter} from "./basic/LocalizedRouter";

export const AppRoute = {
    home: 'routes.home',
    game1: 'routes.game1',
    game2: 'routes.game2',
    game3: 'routes.game3',
    game4: 'routes.game4',
    game5: 'routes.game5',
};

export const appStings = {
    'de': MessagesDe,
    'en': MessagesEn
};

ReactDOM.render(
  <React.StrictMode>
      <LocalizedRouter RouterComponent={BrowserRouter}
                       appStrings={appStings}
                       defaultLanguage={'de'}>
          <LocalizedSwitch>
              <Route exact path={AppRoute.home} component={App} />
              <Redirect to="/" />
          </LocalizedSwitch>

      </LocalizedRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
